import { logError } from 'helpers/logger';

export function getApiUrl() {
    if (!window.__TOTENV__) {
        const message = 'Unhandled __TOTENV__';
        const tags = { __TOTENV__: window.__TOTENV__ };
        logError({ message, tags });
        throw Error('Unhandled __TOTENV__');
    }
    return window.__TOTENV__.API_URL;
}

export function getGraphQLUrl() {
    return `${getApiUrl()}/graphql`;
}

export function getGraphQLWebSocketUrl() {
    if (!window.__TOTENV__) {
        const message = 'Unhandled __TOTENV__';
        const tags = { __TOTENV__: window.__TOTENV__ };
        logError({ message, tags });
        throw Error('Unhandled __TOTENV__');
    }
    return window.__TOTENV__.GRAPHQL_WEBSOCKET_URL;
}
